// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__354yB","title":"FrontImage_title__aRKFR"};